import React from 'react';
import { DetailsFormSection } from '@/components';
import { IBulletinFormValues, BulletinFormFieldHandler, BulletinFormErrors } from '@/types/admin/bulletins';

interface BulletinDetailsSectionProps {
  formData: IBulletinFormValues;
  errors: BulletinFormErrors;
  onFieldChange: BulletinFormFieldHandler;
}

const bulletinFields = [
  {
    key: 'title',
    label: 'Title',
    placeholder: 'Bulletin Title',
    required: true,
    autoCapitalize: 'sentences' as const,
    autoCorrect: true,
  },
  {
    key: 'message',
    label: 'Message',
    placeholder: 'Bulletin Message',
    required: true,
    multiline: true,
    numberOfLines: 6,
    autoCapitalize: 'sentences' as const,
    autoCorrect: true,
  },
];

export const BulletinDetailsSection: React.FC<BulletinDetailsSectionProps> = ({
  formData,
  errors,
  onFieldChange,
}) => {
  return (
    <DetailsFormSection
      title="New Bulletin"
      subtitle=""
      formData={formData}
      errors={errors}
      onFieldChange={onFieldChange}
      fields={bulletinFields}
    />
  );
};
